import React, { useState } from 'react';

import clsx from 'clsx';

import { ChildrenProps, ClassNameProps } from '@/types/common.types';

import styles from '@/components/Slider/ScrollToItemSlider.module.scss';
import { Swiper, SwiperClass, SwiperSlide } from '@/components/Slider/Swiper';

// =================================================================

interface ScrollToItemSliderProps extends ClassNameProps, ChildrenProps {
  handleChangeSlide?: (index: number) => void;
}

// =================================================================

export const ScrollToItemSlider = (props: ScrollToItemSliderProps) => {
  const { children, className, handleChangeSlide } = props;
  const [activeIndex, setActiveIndex] = useState(0);
  const [swiper, setSwiper] = useState<SwiperClass | null>(null);

  const handleSlideChange = (swiper: SwiperClass) => {
    setActiveIndex(swiper.activeIndex);
  };

  const handleClick = (index: number) => {
    setActiveIndex(index);
    if (swiper) {
      swiper.slideTo(index);
    }

    if (typeof handleChangeSlide === 'function') {
      handleChangeSlide(index);
    }
  };

  return (
    <div className={styles.scrollToItemSliderWrapper}>
      <Swiper
        wrapperTag="ul"
        spaceBetween={12}
        onSlideChange={handleSlideChange}
        onActiveIndexChange={swiper => {
          if (typeof handleChangeSlide === 'function') {
            handleChangeSlide(swiper?.activeIndex);
          }
        }}
        mousewheel={{
          forceToAxis: true,
          thresholdDelta: 25,
          thresholdTime: 50,
        }}
        onSwiper={setSwiper}
        slidesPerView={1.01}
        centeredSlides
        className={className}
      >
        {React.Children.map(children, (child, index) => {
          if (child) {
            return (
              <SwiperSlide tag="li" onClick={() => handleClick(index)}>
                {child}
              </SwiperSlide>
            );
          }
          return null;
        })}
      </Swiper>
      <div className={styles.paginationWrapper}>
        {React.Children.map(children, (child, index) => {
          if (child) {
            return (
              <div
                key={index}
                onClick={() => handleClick(index)}
                className={clsx(styles.dot, {
                  [styles.activeDot]: activeIndex === index,
                })}
              />
            );
          }
          return null;
        })}
      </div>
    </div>
  );
};
